import { jsx as _jsx } from "react/jsx-runtime";
import { Box, freddyTheme as theme } from '@coolblue-development/freddy';
export const ModalFooter = ({ children }) => {
    return (_jsx(Box, { sx: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: theme.spacing[200],
            padding: `${theme.spacing[200]} ${theme.spacing[300]}`,
            [theme.breakpoint.minWidth('md')]: {
                paddingLeft: theme.spacing[500],
                paddingRight: theme.spacing[500],
            },
            position: 'sticky',
            bottom: 0,
            background: 'inherit',
            boxShadow: theme.shadow.soft,
        }, children: children }));
};
//# sourceMappingURL=CookieModalFooter.js.map